import * as _ from 'lodash';

export const mapStyleUrl: string = 'mapbox://styles/marisadmin/clwj91ua300iu01pceatr4tdc'
export const mapAccessToken: string = 'pk.eyJ1IjoidHJpdmVjdG9yeCIsImEiOiJja2g2cWhqZjYwYmQzMnpsMmF6MDI5b29nIn0.q37oXpOmezJCRhsGqWXaUw'

export const defaultCenter: number[] = [0, 0]
export const defaultZoom = 2.5
export const minZoom = 1
export const maxZoom = 12
